import { Icon } from "@opendash/icons";
import { FloatButton } from "antd";
import React from "react";

export default (props: { onClick: Function; title: string }) => {
  return (
    <FloatButton
      onClick={() => props.onClick()}
      icon={<Icon icon="fa:question" />}
      tooltip={props.title}
    />
  );
};
